import { matchPath, match } from 'react-router';
import { RouteConfig } from '~/config/routes/types';

export type Branch = {
  route: RouteConfig;
  match: match;
};

export const matchRoutes = (
  routes: RouteConfig[],
  pathname: string,
  branch: Branch[] = []
) => {
  routes.some(route => {
    const match = route.path
      ? matchPath(pathname, route)
      : branch.length
        ? branch[branch.length - 1].match // use parent match
        : { path: '/', url: '/', params: {}, isExact: pathname === '/' };

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, branch);
      }
    }

    return match;
  });

  return branch;
};

export const isSwedishDomainOnlyBranch = (branch: Branch[]) =>
  branch.some(({ route }) => route.swedishDomainOnly);
